import { render } from "./EventFinance.vue?vue&type=template&id=ca4c152e&scoped=true"
import script from "./EventFinance.vue?vue&type=script&lang=js"
export * from "./EventFinance.vue?vue&type=script&lang=js"

import "./EventFinance.vue?vue&type=style&index=0&id=ca4c152e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4c152e"]])

export default __exports__